<template>
    <div>
        <div id="comparison-container" style="position: relative; height: 100vh;">
            <div id="before" class="map"></div>
            <div id="after" class="map"></div>

        </div>

        <div class="scrollytelling-container" style="overflow-y: auto;">
            <div class="step step-1">
                <div class="step-content">
                    <img src="@/assets/burden.svg" alt="Housing Burden" class="scroll-svg" id="burden-svg">
                </div>
            </div>
            <div class="step step-2">
                <div class="step-content">
                    <img src="@/assets/rent.svg" alt="Rent Vacancy" class="scroll-svg" id="rent-svg">
                </div>
            </div>
            <div class="step step-3">
                <div class="step-content">
                    <h2>At the same time, office real estate is struggling with high vacancy rates.</h2>
                </div>
            </div>
            <div class="step step-3.2">
                <div class="step-content">
                    <img src="@/assets/coy.svg" alt="CoY" class="scroll-svg" id="coy-svg">
                </div>
            </div>
            <div class="step step-4">
                <div class="step-content">
                    <h2>Explore how the offices can be converted into affordable homes.</h2>
                    <!-- <button @click="exploreMap">Explore Map</button> -->
                    <button @click="exploreMap">Explore Map</button>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import MapboxCompare from 'mapbox-gl-compare';
import router from '../router'; // Importing default export


export default {
    name: 'IntegratedMapScrollytelling',
    data() {
        return {

            beforeMap: null,
            afterMap: null,
            mapCompare: null,
        };

    },
    mounted() {
        this.$nextTick(() => {
            this.initializeMaps();
            this.addCustomSliderBox();
            this.setupHtmlLabels();  // Make sure this is called after the maps are initialized

        });
    },

    methods: {
        initializeMaps() {
            mapboxgl.accessToken = 'pk.eyJ1IjoiZWppa2lhIiwiYSI6ImNsbnhmcHhpdzBmamQycW11MTh0YTd5cDEifQ.3DLLa5EJ3mIiwzPdd02nPg'; // Use your actual Mapbox access token

            this.beforeMap = new mapboxgl.Map({
                container: 'before',
                style: 'mapbox://styles/mapbox/light-v10',
                center: [-73.977218, 40.748628],
                zoom: 10,
                minZoom: 9
            });

            this.afterMap = new mapboxgl.Map({
                container: 'after',
                style: 'mapbox://styles/mapbox/light-v10',
                center: [-73.977218, 40.748628],
                zoom: 10,
                minZoom: 9
            });

            this.beforeMap.on('load', () => {
                this.setupHtmlLabels();  // Ensuring labels are added after the map loads
            });



            // Ensure that the setupCompare is called only after GeoJSON data has been loaded and layers set up
            Promise.all([
                new Promise(resolve => this.beforeMap.on('load', resolve)),
                new Promise(resolve => this.afterMap.on('load', resolve))
            ]).then(async () => {
                await this.loadAndMergeGeoJSON();
                this.setupCompare();

            });
        },

        async loadAndMergeGeoJSON() {

            try {

                const vacancyResponse = await fetch(`${process.env.BASE_URL}vacancy_data.geojson`);
                const vacancyData = await vacancyResponse.json();
                const boundariesResponse = await fetch(`${process.env.BASE_URL}Borough Boundaries.geojson`);
                const boundariesData = await boundariesResponse.json();

                boundariesData.features.forEach(borough => {
                    const vacancyInfo = vacancyData.features.find(v => v.properties.name === borough.properties.boro_name);
                    if (vacancyInfo) {
                        borough.properties.vacancy_before = vacancyInfo.properties.vacancy_before;
                        borough.properties.vacancy_after = vacancyInfo.properties.vacancy_after;
                    }
                });

                // Setup each map with the appropriate data
                this.setupMapLayers(this.beforeMap, boundariesData, 'vacancy_before');
                this.setupMapLayers(this.afterMap, boundariesData, 'vacancy_after');
            } catch (error) {
                console.error('Error loading or merging GeoJSON data:', error);
            }
        },

        setupMapLayers(map, data, property) {
            if (map.getLayer('previousLayer')) {
                map.moveLayer('vacancy-labels', 'previousLayer');  // Move the labels layer to the top
            }

            map.addSource('borough-data', {
                type: 'geojson',
                data: data
            });

            // Fill layer for showing geographic data
            map.addLayer({
                id: `${property}-layer`,
                type: 'fill',
                source: 'borough-data',
                paint: {
                    'fill-color': [
                        'interpolate',
                        ['linear'],
                        ['get', property],
                        0, '#ffffcc',
                        10, '#800026'
                    ],
                    'fill-opacity': 0.75
                }
            });


        },
        setupHtmlLabels() {
            const geojsonData = {
                "type": "FeatureCollection",
                "features": [
                    {
                        "type": "Feature",
                        "properties": {
                            "vacancy_before": 8.30,
                            "vacancy_after": 14.20
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-73.9712, 40.7831]
                        }
                    },
                    {
                        "type": "Feature",
                        "properties": {
                            "vacancy_before": 7.31,
                            "vacancy_after": 14.89
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-73.9442, 40.6782]
                        }
                    },
                    {
                        "type": "Feature",
                        "properties": {
                            "vacancy_before": 6.66,
                            "vacancy_after": 8.15
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-73.8648, 40.8448]
                        }
                    },
                    {
                        "type": "Feature",
                        "properties": {
                            "vacancy_before": 0.52,
                            "vacancy_after": 3.31
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-73.7949, 40.7282]
                        }
                    },
                    {
                        "type": "Feature",
                        "properties": {
                            "vacancy_before": 3.30,
                            "vacancy_after": 6.90
                        },
                        "geometry": {
                            "type": "Point",
                            "coordinates": [-74.1502, 40.5795]
                        }
                    }
                ]
            };
            geojsonData.features.forEach(feature => {
                const el = document.createElement('div');
                el.className = 'custom-label';
                el.textContent = ` ${feature.properties.vacancy_before}%`;  // Adjust this line

                new mapboxgl.Marker(el)
                    .setLngLat(feature.geometry.coordinates)
                    .addTo(this.beforeMap);  // Add it to the map
            });
            geojsonData.features.forEach(feature => {
                const el = document.createElement('div');
                el.className = 'custom-label';
                el.textContent = ` ${feature.properties.vacancy_after}%`;  // Adjust this line

                new mapboxgl.Marker(el)
                    .setLngLat(feature.geometry.coordinates)
                    .addTo(this.afterMap);  // Add it to the map
            });
        },



        setupCompare() {
            this.mapCompare = new MapboxCompare(this.beforeMap, this.afterMap, '#comparison-container', {
                mousemove: true,
                orientation: 'vertical'
            });

            // Assuming you have a method to get the slider position or listen for its change
            const slider = document.querySelector('.mapboxgl-compare-slider');
            slider.addEventListener('mousemove', () => {
                const sliderPosition = slider.getBoundingClientRect().left;
                const mapContainerRect = this.beforeMap.getContainer().getBoundingClientRect();

                const beforeMapVisible = sliderPosition > mapContainerRect.left;
                const afterMapVisible = sliderPosition < mapContainerRect.right;

                // Set label visibility based on slider position
                this.beforeMap.setLayoutProperty('vacancy_before-label', 'visibility', beforeMapVisible ? 'visible' : 'none');
                this.afterMap.setLayoutProperty('vacancy_after-label', 'visibility', afterMapVisible ? 'visible' : 'none');
            });
        },
        exploreMap() {
            console.log("Button clicked!");
            router.push('/officemap').catch(err => {
                console.error("Router error:", err);
            });
        },
    }
}
</script>

<style>
#comparison-container {
    position: relative;
    height: 100vh;
    overflow: visible;
}

.mapboxgl-compare {
    background-color: #fff;
    position: absolute;
    width: 10px;
    height: 100%;
    z-index: 2000;


}

.mapboxgl-compare .compare-swiper-vertical {
    display: inline-block;
    position: absolute;
    width: 360px;
    height: 160px;
    top: 50%;
    left: -162px;
    margin: -30px 1px 0;
    color: #a72e2e;
    cursor: ew-resize;
    background-image: url(https://svgshare.com/i/15hK.svg);
    /* Assuming this path is correct */
    background-size: cover;
    /* Cover the area of the slider */
    background-position: center;
    /* Center the image within the slider */
    z-index: 3000;
}


.map {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.scrollytelling-container {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}

.step-content {
    /* margin: 0 auto; */
    width: 50%;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    pointer-events: none;
    z-index: 2000;
}

.step {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

h2 {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 500;
    /* Medium is usually around 500 weight */
    font-size: 25pt;
}

.custom-label {
    /* background-color: white; */
    padding: 5px 10px;
    border-radius: 5px;
    /* border: 1px solid #ccc; */
    text-align: center;
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 500;
    /* Medium is usually around 500 weight */
    font-size: 15pt;


}

button {
    background-color: #3887be;
    /* Customize color */
    border-color: #3887be;
    color: #fff;
    border-radius: 50px;
    /* Text color */
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 400;
    /* Medium is usually around 500 weight */
    font-size: 25pt;
    padding: 10px 20px;
    z-index: 10000;
    pointer-events: auto;
    /* This is the default value and allows the button to receive mouse events */

    /* Adjusts the font size inside the button */
}

.label {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 500;
    /* Medium is usually around 500 weight */
    font-size: 15pt;
}
</style>